import { render } from "./SpecimenActions.vue?vue&type=template&id=390d6f30&scoped=true"
import script from "./SpecimenActions.vue?vue&type=script&lang=js"
export * from "./SpecimenActions.vue?vue&type=script&lang=js"

import "./SpecimenActions.vue?vue&type=style&index=0&id=390d6f30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390d6f30"]])

export default __exports__